import React, { useState } from 'react';
import { observer } from 'mobx-react';
import BackgroundView from './BackgroundView';
import DifferentiatorsView from './DifferentiatorsView';
import ProblemsView from './ProblemsView';
import CompetitorsView from './CompetitorsView';
import ProspectProfileView from './ProspectProfileView';
import EditWrapper from './EditWrapper';

// V1 edit components (reused as-is for edit mode)
import CompanyBackground from '../../components/CompanyOverview/CompanyBackground';
import Differentiators from '../../components/CompanyOverview/Differentiators';
import AddressableProblems from '../../components/CompanyOverview/AddressableProblems';
import TopCompetitors from '../../components/CompanyOverview/TopCompetitors';
import ProspectProfile from '../../components/CompanyOverview/ProspectProfile';

import {
  PageWrapper, PageHeader, PageTitle, EditButton, TabBar, Tab,
} from './CompanyPage.styles';

const TABS = [
  { key: 'background', label: 'Background' },
  { key: 'differentiators', label: 'Differentiators' },
  { key: 'competitors', label: 'Competitors' },
  { key: 'problems', label: 'Addressable Problems' },
  { key: 'prospects', label: 'Prospect Profile' },
];

const CompanyPage = observer(({ company, mode }) => {
  const [activeTab, setActiveTab] = useState('background');
  const [editing, setEditing] = useState(false);
  const isReadonly = mode === 'readonly';

  const renderReadonlyView = () => {
    switch (activeTab) {
      case 'background':
        return <BackgroundView background={company.background} />;
      case 'differentiators':
        return <DifferentiatorsView differentiators={company.differentiators} />;
      case 'problems':
        return <ProblemsView problems={company.addressableProblems} />;
      case 'competitors':
        return <CompetitorsView competitors={company.topCompetitors} />;
      case 'prospects':
        return <ProspectProfileView profiles={company.prospectProfile} />;
      default:
        return null;
    }
  };

  const renderEditView = () => {
    const onBack = () => setEditing(false);

    switch (activeTab) {
      case 'background':
        return (
          <EditWrapper onBack={onBack}>
            <CompanyBackground companyBackground={company.background} />
          </EditWrapper>
        );
      case 'differentiators':
        return (
          <EditWrapper onBack={onBack}>
            <Differentiators company={company} />
          </EditWrapper>
        );
      case 'problems':
        return (
          <EditWrapper onBack={onBack}>
            <AddressableProblems company={company} />
          </EditWrapper>
        );
      case 'competitors':
        return (
          <EditWrapper onBack={onBack}>
            <TopCompetitors company={company} />
          </EditWrapper>
        );
      case 'prospects':
        return (
          <EditWrapper onBack={onBack}>
            <ProspectProfile company={company} />
          </EditWrapper>
        );
      default:
        return null;
    }
  };

  return (
    <PageWrapper data-tour="company-page">
      <PageHeader>
        <PageTitle>Company Overview</PageTitle>
        {!isReadonly && !editing && (
          <EditButton onClick={() => setEditing(true)}>
            {'\u270E'} Edit
          </EditButton>
        )}
      </PageHeader>

      <TabBar>
        {TABS.map((tab) => (
          <Tab
            key={tab.key}
            $active={activeTab === tab.key}
            onClick={() => { setActiveTab(tab.key); setEditing(false); }}
          >
            {tab.label}
          </Tab>
        ))}
      </TabBar>

      {editing ? renderEditView() : renderReadonlyView()}
    </PageWrapper>
  );
});

export default CompanyPage;
